import { prioritizeClubhouseRounds } from "../../../shared/presentation/clubhouse-feed-order.js";
import { CardGallery } from "../../components/card-gallery.js";
import { Button } from "../../components/ui/button.js";
import { ArrowUpRight } from "../../shell/approved-icons.js";
import { RoundPosterTile } from "./round-poster-tile.js";
import { useRoundFeed } from "./use-round-feed.js";

export function RoundFeedCarousel(props: {
  revision: string;
  viewerParticipantIds?: string[];
  onOpen(id: string): void;
  onAll?(): void;
  social?: boolean;
  empty?: React.ReactNode;
}) {
  const feed = useRoundFeed(props.revision);
  if (!feed.items.length)
    return feed.error ? (
      <Button variant="ghost" onClick={feed.retry}>
        Reload round results
      </Button>
    ) : feed.loading ? null : (
      (props.empty ?? null)
    );
  return (
    <section className="fr-home-result-feed" aria-label="Around your clubhouse">
      <header>
        <div>
          <h2>Around your clubhouse</h2>
        </div>
        {props.onAll && (
          <Button
            variant="ghost"
            onClick={props.onAll}
            aria-label="Open all round results"
          >
            <ArrowUpRight />
          </Button>
        )}
      </header>
      <CardGallery
        label="round results"
        more={feed.nextCursor ? feed.more : undefined}
        loading={feed.loading}
      >
        {prioritizeClubhouseRounds(
          feed.items,
          props.viewerParticipantIds ?? [],
        ).map((item) => (
          <RoundPosterTile
            key={item.card.roundId}
            card={item.card}
            actions={false}
            event={item.event}
            social={props.social ?? false}
            onOpen={() => props.onOpen(item.card.roundId)}
          />
        ))}
      </CardGallery>
      {feed.error && (
        <p role="alert">
          {feed.error}{" "}
          <Button variant="ghost" onClick={feed.more}>
            Try again
          </Button>
        </p>
      )}
    </section>
  );
}
